import React, { lazy } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { USER_ROLES } from "../const";
import MainLayout from "../layouts/MainLayout";
import LoadingFallback from "../components/ui/LoadingFallback";

const LandingPage = lazy(() => import("../pages/member/LandingPage"));
const HomePage = lazy(() => import("../pages/member/HomePage"));

const RootRoute = () => {
  const { isAuthenticated, loading, user } = useAuth();

  if (loading) {
    return <LoadingFallback />;
  }

  if (!isAuthenticated) {
    return <LandingPage />;
  }

  if (user?.role?.toLowerCase?.() === USER_ROLES.SUPER_ADMIN) {
    return <Navigate to="/super-admin" replace />;
  }

  return (
    <MainLayout>
      <HomePage />
    </MainLayout>
  );
};

export default RootRoute;
